import React from "react";
import styled from "styled-components";
import { Tag } from "antd";
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { formatPhoneNumber } from "../../utils/emailUtils";

const HandymanItem = ({ vendor, onEdit }) => {
  return (
    <HandymanItemContainer onClick={() => onEdit(vendor)}>
      <HandymanAvatar>
        <WhiteIcon>
          <UserOutlined />
        </WhiteIcon>
      </HandymanAvatar>
      <HandymanInfo>
        <HandymanName>{vendor.name}</HandymanName>
        <HandymanDetails>
          <span>
            <PhoneOutlined /> {formatPhoneNumber(vendor.phone)}
          </span>
          <span>
            <MailOutlined /> {vendor.email}
          </span>
        </HandymanDetails>
        <HandymanSpecialties>
          {vendor.specialties?.map((specialty) => (
            <Tag key={specialty} color="blue">
              {specialty.charAt(0).toUpperCase() + specialty.slice(1)}
            </Tag>
          ))}
        </HandymanSpecialties>
      </HandymanInfo>
      <HandymanActions>
        <EditIcon
          onClick={(e) => {
            e.stopPropagation();
            onEdit(vendor);
          }}
        >
          <EditOutlined />
        </EditIcon>
      </HandymanActions>
    </HandymanItemContainer>
  );
};

// Styled Components
const HandymanItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 0;
  overflow: hidden;

  &:hover {
    border-color: var(--color-primary);
    box-shadow: 0 2px 8px rgba(44, 95, 45, 0.1);
  }

  @media (max-width: 768px) {
    padding: 0.75rem;
    gap: 0.75rem;
    margin: 0 0.5rem;
  }
`;

const HandymanAvatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0;
`;

const HandymanInfo = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

const HandymanName = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.25rem;
  font-family: var(--font-secondary);
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const HandymanDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;

  span {
    font-size: 0.85rem;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 768px) {
    span {
      font-size: 0.8rem;
    }
  }
`;

const HandymanSpecialties = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  .ant-tag {
    font-size: 0.75rem;
    padding: 2px 8px;
    margin: 0;
    border-radius: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;

    @media (max-width: 768px) {
      font-size: 0.7rem;
      padding: 1px 6px;
      max-width: 80px;
    }
  }
`;

const HandymanActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
  }
`;

const EditIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.2);
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
`;

const WhiteIcon = styled.div`
  color: white;
`;

export default HandymanItem;
